import React from "react";
import { useTranslation } from "next-i18next";
import ConfirmModal from "../common/ConfirmModal";

export default function OpenAccountModal({
	visible,
	onClose,
	onConfirm,
}: {
	visible: boolean;
	onClose: () => void;
	onConfirm: () => void;
}) {
	const { t } = useTranslation("activities");

	return (
		<ConfirmModal
			visible={visible}
			onClose={onClose}
			title={t("account-and-deposit-required")}
			onCancel={onClose}
			onCancelText={t("later", { ns: "common" })}
			onOk={onConfirm}
			onOkText={t("go-now", { ns: "common" })}
		>
			{t("you-need-to-open-an-account-and-make-a-deposit-first")}
		</ConfirmModal>
	);
}
